import React, { createContext, useContext } from 'react';

const RequestFilterCommandsContext = createContext(null);

export const RequestFilterCommandsProvider = ({ commands, children }) => (
  <RequestFilterCommandsContext.Provider value={commands}>
    {children}
  </RequestFilterCommandsContext.Provider>
);

export const useRequestFilterCommands = () => {
  const commands = useContext(RequestFilterCommandsContext);

  if (!commands) {
    throw new Error(
      'RequestFilter must be rendered with a request commands adapter'
    );
  }

  return commands;
};
